module.exports = "<fb-li-select value=\"item\" on-select=\"$ctrl.toggle(value)\" selection=\"$ctrl.value\" on-create=\"$ctrl.create(displayName, parent)\" ng-repeat=\"item in $ctrl.list | emptyItem track by item.id\"></fb-li-select>\n"


//////////////////
// WEBPACK FOOTER
// ./project/components/fb-ol-select/fb-ol-select.html
// module id = 819
// module chunks = 3